import React, { useState } from 'react';
import { ChevronDown, ChevronRight, User } from 'lucide-react';
import CaseOverview from './CaseOverview';
import CaseContact from './CaseContact';
import CaseTimeline from './CaseTimeline';

// Tab-consolidation: Overview absorbs Contact as a collapsible section.
// (Settings was entirely billing/prepaid config → moved into Time & Billing,
// so there is no non-billing "settings" content to fold here.)
// Case Timeline lives here (not a 7th tab) — the 22→6 consolidation is deliberate.
const CaseOverviewTab = ({ caseData, caseId, onRefresh }) => {
  const [showContact, setShowContact] = useState(false);

  return (
    <div>
      <CaseOverview caseData={caseData} onRefresh={onRefresh} />

      <div className="mt-6 border-t border-virgo-navy-600 pt-4">
        <CaseTimeline caseId={caseId} />
      </div>

      <div className="mt-6 border-t border-virgo-navy-600 pt-4">
        <button
          onClick={() => setShowContact((v) => !v)}
          className="flex items-center gap-2 text-virgo-gold-400 hover:text-virgo-gold-300 font-semibold"
        >
          {showContact ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
          <User size={16} /> Client Contact
        </button>
        {showContact && (
          <div className="mt-4">
            <CaseContact caseId={caseId} caseData={caseData} onRefresh={onRefresh} />
          </div>
        )}
      </div>
    </div>
  );
};

export default CaseOverviewTab;
